import { render, staticRenderFns } from "./NewsController.vue?vue&type=template&id=cd3794a6"
import script from "./NewsController.vue?vue&type=script&lang=js"
export * from "./NewsController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports